"use client";
import React, { useState, useEffect, useRef } from "react";
import { useRouter, usePathname, useSearchParams } from "next/navigation";
import { Navbar, NavDropdown, Nav, Container } from "react-bootstrap";
import Stack from "react-bootstrap/Stack";
import Link from "next/link";
import "@/styles/MainMenu.scss";
import logo from "@/public/assets/images/eXp-Realty-Logo-Color.svg";
import Image from "next/image";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Ratio from "react-bootstrap/Ratio";
import parse, { attributesToProps, domToReact } from "html-react-parser";
import Badge from "react-bootstrap/Badge";
import { useQuery, useQueryClient, useMutation } from "@tanstack/react-query";
import { TanstackStateInitializerProps } from "@/components/services/TanstackStateInitializer";
import { modalHelper, postFormData } from "@/components/services/QueryDataHelper";
import type { ModalMessage } from "@/types/data.types";
import Button from "@/components/Button";

export const MainMenu = () => {
  const { data: currentState } = useQuery<TanstackStateInitializerProps>({
    queryKey: ["RES-DATA"],
  });
  const {mutate: postForms,
    data, isSuccess, isError, error
  } = useMutation({
    mutationKey: ["FORM-DATA"],
    mutationFn: (formData:any) => postFormData(formData)
  });
  const queryClient = useQueryClient();
  const { setModal, setModalVideo, setSubdivision, setResultModal } = modalHelper(queryClient);
  // const location = useLocation();
  const router = useRouter();
  const pathname = usePathname(); //location.href
  const searchParams = useSearchParams(); // location.search
  // const [getWidth, setWidth] = useState(window.innerWidth);
  const [showMenu, setShowMenu] = useState(true);
  const [formValues, setFormValues] = useState<any>({ cs: 0 });
  const [validated, setValidated] = useState(false);
  // const [ postForms, {isLoading, data, isSuccess, isError} ] = usePostFormsMutation();
  const formCalc = useRef(null);
  //temp letiables

  const pricePoint = 0;
  const isLoading = false;
  //temp variables

  // const currentState?.currentModal = useSelector(selectModal);
  // const modalVideoUrl = useSelector(selectModalVideoUrl);
  // const pricePoint = useSelector(selectPricePoint);
  // const subdivision = useSelector(selectSubdivision);
  // const resultHeader = useSelector(selectResultHeader);
  // const resultBody = useSelector(selectResultBody);
  // const resultFooter = useSelector(selectResultFooter);

  const Pending = (
    <Badge className="m-badge" text="dark" bg="warning">
      Pending
    </Badge>
  );
  const Sold = (
    <Badge className="m-badge" bg="danger">
      Sold
    </Badge>
  );

  const handleChange = (event: any) => {
    const val = event.target.value;
    const id = event.target.id;
    if (event.target.dataset["type"] === "mce-phone") {
      const area =
        val.indexOf("-") > 0 ? val.split("-")[0] : val.substring(0, 3);
      const prefix =
        val.indexOf("-") > 0 ? val.split("-")[1] : val.substring(3, 6);
      const suffix =
        val.indexOf("-") > 0 ? val.split("-")[2] : val.substring(6, 10);
      const newformValues = {
        ...formValues,
        [id.toLowerCase().replace("mce-", "")]: val,
        ["phone-area"]: area,
        ["phone-detail1"]: prefix,
        ["phone-detail2"]: suffix,
      };
      setFormValues(newformValues);
    } else if (event.target.dataset["type"] === "mce") {
      const newformValues = {
        ...formValues,
        [id.toLowerCase().replace("mce-", "")]: val,
      };
      setFormValues(newformValues);
    } else if (id == "neighborhood") {
      const newformValues = {
        ...formValues,
        [id]: val,
      };
      setFormValues(newformValues);
      setSubdivision(val);
    } else if (id == "amount") {
      const newformValues = {
        ...formValues,
        [id]: val,
        payments: "",
      };
      setFormValues(newformValues);
    } else if (id == "payments") {
      const newformValues = {
        ...formValues,
        [id]: val,
        amount: "",
      };
      setFormValues(newformValues);
    } else {
      const newformValues = {
        ...formValues,
        [id]: val,
      };
      setFormValues(newformValues);
    }
    event.target.focus();
  };

  const handleSubmit = (event: any) => {
    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidated(true);
    } else {
      event.preventDefault();
      event.stopPropagation();
      console.log(form.elements);
      let formCookies = {};
      let formName = form.elements.cta.value.toLowerCase();
      let postUrl = "form";
      let storeFormData = true;
      for (let x = 0; x < form.elements.length; x++) {
        switch (form.elements[x].id) {
          case "cs":
            {
              if (
                Number(form.elements.ts.value) >
                Number(form.elements[x].value) + 1
              ) {
                formCookies = {
                  ...formCookies,
                  [form.elements[x].id]: Number(form.elements[x].value) + 1,
                };
                const newformValues = {
                  ...formValues,
                  [form.elements[x].id]: Number(form.elements[x].value) + 1,
                };
                setFormValues(newformValues);
              }
            }
            break;
          case "fullname":
          case "fname":
          case "lname":
          case "mobile":
          case "email":
            {
              formCookies = {
                ...formCookies,
                [form.elements[x].id]: form.elements[x].value,
              };
            }
            break;
          case "mce-FNAME":
          case "mce-LNAME":
          case "mce-EMAIL":
          case "mce-PHONE-area":
          case "mce-PHONE-detail1":
          case "mce-PHONE-detail2":
            {
              formCookies = {
                ...formCookies,
                [form.elements[x].id.toLowerCase().replace("mce-", "")]:
                  form.elements[x].value,
              };
            }
            break;
          default:
            break;
        }
      }

      switch (formName) {
        case "justsold":
          {
            storeFormData = true;
          }
          break;
        case "marketnewsletter":
          {
            storeFormData = true;
          }
          break;
        case "feedback":
          {
            storeFormData = false;
            postUrl = "feedback";
          }
          break;
        default:
          {
            storeFormData = true;
            formName = "formData";
          }
          break;
      }
      if (storeFormData)
        localStorage.setItem(formName, JSON.stringify(formCookies));
      let canSubmit =
        Number(form.elements.cs.value) + 1 >= Number(form.elements.ts.value);
      setValidated(canSubmit);
      if (canSubmit) {
        const postDataValues = {
          ...formValues,
          neighborhood: form.elements.neighborhood?.value,
          cs: Number(form.elements.cs.value) + 1,
          ts: Number(form.elements.ts.value),
          cta: form.elements.cta.value,
          sto: form.elements.sto ? form.elements.sto.value : null,
          url: window.location.href,
        };
        postForms({data:postDataValues, api:postUrl});
      }
    }
  };

  const Currency = (num: number) => {
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",

      // These options are needed to round to whole numbers if that"s what you want.
      //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
      //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    });
    return formatter.format(num);
  };

  const CheckForm = (form: any, type: string) => {
    form.amount.value = form.amount.value.replace(",", "").replace("$", "");
    form.payments.value = form.payments.value.replace(",", "").replace("$", "");

    if (type == "payment" && form.amount.value.trim() == "") {
      form.amount.required = true;
      setValidated(true);
      form.checkValidity();

      form.amount.focus();
      return false;
    }
    if (type == "amount" && form.payments.value.trim() == "") {
      form.payments.required = true;
      setValidated(true);
      form.checkValidity();

      form.payments.focus();
      return false;
    }
    return true;
  };

  const CalcMortgage = (type: string) => {
    const form:any = formCalc.current;
    if (type == "reset") {
      form.amount.required = false;
      form.payments.required = false;
      let newformValues:any = {};
      newformValues = {
        ...formValues,
        cs: 1,
        amount: "",
        payments: "",
        term: 20,
        rate: 5.0,
      };
      setFormValues(newformValues);
      setValidated(false);
    } else if (form.checkValidity() === false) {
      setValidated(true);
    } else {
      CheckForm(form, type);
      if (CheckForm(form, type)) {
        let n = form.term.value * 12;
        let r = form.rate.value / 1200;
        let a = form.amount.value;
        let p = form.payments.value;

        if (type == "payment") {
          p =
            (a * (1200 * r) * Math.pow(1 + r, n)) /
            (1200 * (Math.pow(1 + r, n) - 1));
        } else if (type == "amount") {
          a =
            (p / (1200 * r * Math.pow(1 + r, n))) *
            (1200 * (Math.pow(1 + r, n) - 1));
        }
        form.payments.value = Currency(p);
        form.amount.value = Currency(a);
      }
    }
  };

  const htmlFrom = (htmlString:string|null): any => {
    if(htmlString) {    
    //const cleanHtmlString = DOMPurify.sanitize(htmlString,
    //  { USE_PROFILES: { html: true } });
    //const html = parse(cleanHtmlString, {
        const html = parse(htmlString, {
        replace: ({ name, attribs, children }: any) => {
            if (attribs?.["data-react"] === "true") {
                const props = attributesToProps(attribs);
                const {"data-react":dataReact, onclick, ...rest} = props;
                const reactElements: { [key: string]: React.ComponentType<any> } = {"Button":Button, "Modal.Title": Modal.Title};
                const Type = reactElements[name?.replace(/(\b[a-z](?!\s))/g, (c:string) => c.toUpperCase()) ?? ''];
                return <Type {...rest} onClick={onclick ? () => new Function(onclick as string)() : undefined}>{domToReact(children as any)}</Type>;
            }
          }
        });
        return html;
    }
    else return null;
  }

  useEffect(() => {
    if (searchParams.get("displayForm")) {
      setModal(searchParams.get("displayForm") as string);
    }
    if (searchParams.get("frm")) {
      if (searchParams.get("frm")?.toLowerCase() == "vendorbook") {
        if (window.location.href.indexOf("/real-estate/resources") > -1) {
          // setTimeout(window.scrollTo(0, 8000), 2000);
        } else {
          router.push("/real-estate/resources?frm=VendorBook");
        }
      } else {
        if (searchParams.get("frm")?.toLowerCase() == "virtualopenhouse") {
          //TODO: Add logic to get current property virtual open house video
        } else if (
          (searchParams.get("frm")?.toLowerCase() == "marketingvideo" ||
            searchParams.get("frm")?.toLowerCase() == "video") &&
          searchParams.get("v")
        ) {
          let modalVideo = searchParams.get("v");
          if (modalVideo?.startsWith("PL")) {
            setModalVideo(
              `https://www.youtube.com/embed?listType=playlist&list=${modalVideo}&modestbranding=1&autoplay=1&rel=0&fs=0`
            );
          } else {
            setModalVideo(
              `https://www.youtube.com/embed/${modalVideo}?version=3&autoplay=1&rel=0&fs=0&modestbranding=1&mute=1`
            );
          }
        } else if (searchParams.get("frm")?.toLowerCase() == "newsletter") {
          setModal("marketnewsletter");
        } else {
          setModal(searchParams.get("frm") as string);
        }
      }
    }
    if (searchParams.get("nav")) {
      //TODO: Enable nav hide for vTour ((!document.referrer.match(/^https?:\/\/([^\/]+\.)?resluxurygroup\.com(\/|$)/i) || searchParams.get("nav") === "N") && searchParams.get("nav") !== "Y") ? setShowMenu(false) : setShowMenu(true);
      searchParams.get("nav") === "N" ? setShowMenu(false) : setShowMenu(true);
    }
    if (searchParams.get("Neighborhood")) {
      setSubdivision(searchParams.get("Neighborhood") as string);
    }
    if (searchParams.get("neighborhood")) {
      setSubdivision(searchParams.get("neighborhood") as string);
    }
    if (searchParams.get("Subdivision")) {
      setSubdivision(searchParams.get("Subdivision") as string);
    }
    if (searchParams.get("subdivision")) {
      setSubdivision(searchParams.get("subdivision") as string);
    }
    if (searchParams.get("PricePoint")) {
      // dispatch(setPricePoint(searchParams.get("PricePoint")));
    }
  }, [searchParams]);

  useEffect(() => {
    if (currentState?.currentModal != "") {
      let newformValues:any = {};
      if (localStorage["formData"]) {
        newformValues = JSON.parse(localStorage["formData"]);
        newformValues["cs"] = 0;
        if (currentState?.currentModal && localStorage[currentState.currentModal]) {
          newformValues = {
            ...newformValues,
            ...JSON.parse(localStorage[currentState?.currentModal]),
          };
        }
      } else {
        newformValues = { ...formValues, cs: 0 };
      }
      setFormValues(newformValues);
    }
  }, [currentState?.currentModal]);

  useEffect(() => {
      if(isSuccess)
      {
        setResultModal(data.ModalMessage);
          if(currentState?.currentModal === "mortgage-calc")
          {
              const newformValues = {...formValues, cs: 1, term: 20, rate: 5.0};
              setFormValues(newformValues);
              setValidated(false);
          }
          else
          {
            setModal("results");
          }
          if (data?.Action) {
            try {
              const actionFunction = new Function(data.Action);
              actionFunction();
            } catch (error) {
              console.error("Error executing action:", error);
            }
          }
      }
  }, [data]);

  useEffect(() => {
      if(isError)
      {
        const errorModal:ModalMessage = {Header: "<Modal.Title data-react='true'>Error Encountered</Modal.Title>", Body: "<p>This is very embarrassing, but I have encountered a problem while attempting to process your submission. I will have my development team look into the logs and resolve the issue. Thank you for your understanding! Feel free to contact us directly RES Luxury Group, eXp Realty: <a href='tel:+13527941426' aria-label='Click to automatically dial from mobile device' title='Click to automatically dial from mobile device'>352.794.1426</a></p>", Footer: ""}
        setResultModal(errorModal);
          // setResultFooter(<Button size="lg" variant="blue" onClick={()=>dispatch(setModal(""))}>Ok</Button>);
          setModal("results");
      }
  }, [isError]);

  // useEffect(() => {
  //   window.addEventListener("resize", resizeEventHandler);

  //   function resizeEventHandler(event) {
  //     // setWidth(window.innerWidth);
  //     console.log(window.innerWidth);
  //   }

  //   return () => {
  //     // Remove the handler when the component unmounts
  //     window.removeEventListener("resize", resizeEventHandler);
  //   };
  // }, []);

    useEffect(() => {
      window.setModal = setModal;
  }, []);

  const MainForm = () => {
    return (
      <>
        <Row>
          <Col sm="6">
            <Form.Group
              className="form-floating mb-3"
              controlId="fname"
            >
              <Form.Control
                type="text"
                placeholder="First name (Required)"
                maxLength={256}
                value={formValues["fname"] || ""}
                onChange={handleChange}
                required
              />
              <Form.Label>First Name (Required)</Form.Label>
              <Form.Control.Feedback type="invalid">
                Please provide first name.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col sm="6">
            <Form.Group
              className="form-floating mb-3"
              controlId="lname"
            >
              <Form.Control
                type="text"
                placeholder="Last name (Required)"
                maxLength={256}
                value={formValues["lname"] || ""}
                onChange={handleChange}
                required
              />
              <Form.Label>Last Name (Required)</Form.Label>
              <Form.Control.Feedback type="invalid">
                Please provide last name.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col sm="9">
            <Form.Group
              className="form-floating mb-3"
              controlId="email"
            >
              <Form.Control
                type="email"
                placeholder="Email (Required)"
                maxLength={256}
                value={formValues["email"] || ""}
                onChange={handleChange}
                required
              />
              <Form.Label>Email (Required)</Form.Label>
              <Form.Control.Feedback type="invalid">
                Please provide email address.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col sm="3">
            <Form.Group
              className="form-floating mb-3"
              controlId="mobile"
            >
              <Form.Control
                type="tel"
                placeholder="Mobile (Required)"
                value={formValues["mobile"] || ""}
                onChange={handleChange}
                pattern="^\d{3}-?\d{3}-?\d{4}$"
                required
              />
              <Form.Label>Mobile (Required)</Form.Label>
              <Form.Control.Feedback type="invalid">
                Please provide mobile phone number.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>
      </>
    );
  };
// @ts-ignore
  return (
    <>
      <Navbar
        bg="white"
        expand="md"
        fixed="top"
        className={showMenu ? "exp-nav" : "d-none exp-nav"}
      >
        <Container>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Brand href="/">RES Luxury Group</Navbar.Brand>
          {/* TODO: Fix mobile Navbar.Brand layout */}
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <NavDropdown.Item
                as={Link}
                href="/"
                title="RES Luxury Group top producing eXp Realty team of central Florida"
                aria-label="RES Luxury Group top producing eXp Realty team of central Florida"
              >
                <div className="brand-home">RES Luxury Group</div>
              </NavDropdown.Item>
              <NavDropdown
                title={<span className="menu-listing-label" 
                  aria-label="Property Listings"></span>}
                id="basic-nav-dropdown"
              >
                <NavDropdown.Item
                  as={Link}
                  href="/homes-for-sale/Meadowcrest---Fox-Hollow/856325"
                  aria-label="Home for sale at 6264 W Glynborne Loop, Crystal River, FL 34429"
                  title="Home for sale in Crystal River, FL 34429"
                >
                  6264 W Glynborne Loop
                </NavDropdown.Item> 
                <NavDropdown.Item
                  as={Link}
                  href="/homes-for-sale/Marion-County/856184"
                  aria-label="Home for sale at 18303 SW 27th St, Dunnellon, FL 34432"
                  title="Home for sale in Dunnellon"
                >
                  18303 SW 27th St
                </NavDropdown.Item> 
                <NavDropdown.Item
                  as={Link}
                  href="/homes-for-sale/Homosassa-Tradewinds-Condos/855833"
                  aria-label="Home for sale at 10228 W Middleburg Loop #153, Homosassa, FL 34448"
                  title="Home for sale in Homosassa Tradewinds Resort"
                >
                  10228 W Middleburg Loop #153
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  href="/homes-for-sale/Pine-Ridge/855769"
                  aria-label="Home for sale at 2460 W Pine Ridge Blvd, Pine Ridge, FL 34465"
                  title="Home for sale in Pine Ridge"
                >
                  2460 W Pine Ridge Blvd
                </NavDropdown.Item>   
                <NavDropdown.Item
                  as={Link}
                  href="/homes-for-sale/Pine-Ridge/855628"
                  aria-label="Home for sale at 4200 W Pine Ridge Blvd, Pine Ridge, FL 34465"
                  title="Home for sale in Pine Ridge"
                >
                  4200 W Pine Ridge Blvd
                </NavDropdown.Item>                                                  
                <NavDropdown.Item
                  as={Link}
                  href="/homes-for-sale/Pine-Ridge/855556"
                  aria-label="Home for sale at 4081 W Roundup Ct, Pine Ridge, FL 34465"
                  title="Home for sale in Pine Ridge"
                >
                  4081 W Roundup Ct
                </NavDropdown.Item>  
                <NavDropdown.Item
                  as={Link}
                  href="/homes-for-sale/Citrus-Hills---Terra-Vista/854773"
                  aria-label="Home for sale at 1969 N Yawkey Pt, Hernando, FL 34442"
                  title="Home for sale in Citrus Hills - Terra Vista"
                >
                  1969 N Yawkey Pt
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  href="/homes-for-sale/Halls-River-Est./854770"
                  aria-label="Home for sale at 2272 S Todd Pt, Homosassa, FL 34448"
                  title="Home for sale in Homosassa Tradewinds Resort"
                >
                  2272 S Todd Pt
                </NavDropdown.Item> 
                <NavDropdown.Item
                  as={Link}
                  href="/homes-for-sale/Levy-County/852767"
                  aria-label="Home for sale at 35 Captains Cove Rd, Inglis, FL 34449"
                  title="Home for sale in Inglis, Florida"
                >
                  35 Captains Cove Rd
                </NavDropdown.Item>                                           
                <NavDropdown.Item
                  as={Link}
                  href="/homes-for-sale/Mayfield-Acres/852298"
                  aria-label="Home for sale at 265 S Thayer Ave, Lecanto, FL 34461"
                  title="Home for sale in Lecanto, FL 34461"
                >
                  265 S Thayer Ave
                </NavDropdown.Item>                          
                <NavDropdown.Item
                  as={Link}
                  href="/homes-for-sale/Pine-Ridge/849020"
                  aria-label="Home for sale at 4202 N Pony Dr, Pine Ridge, FL 34465"
                  title="Home for sale in Pine Ridge"
                >
                  4202 N Pony Dr
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  href="/homes-for-sale/Sherwood-Forest/848092"
                  aria-label="Home for sale at 353 N Robin Hood Rd, Inverness, FL 34450"
                  title="Home for sale in Sherwood Forest"
                >
                  353 N Robin Hood Rd
                </NavDropdown.Item>      
                <NavDropdown.Item
                  as={Link}
                  href="/homes-for-sale/Citrus-Springs/848108"
                  aria-label="Home for sale at 1628 E Derby Dr, Dunnellon, FL 34434"
                  title="Home for sale in Citrus Springs"
                >
                  1628 E Derby Dr
                </NavDropdown.Item>          
                <NavDropdown.Item
                  as={Link}
                  href="/homes-for-sale/Homosassa-Tradewinds-Condos/845372"
                  aria-label="Home for sale at 10234 W Middleburg Loop #152, Homosassa, FL 34448"
                  title="Home for sale in Homosassa Tradewinds Resort"
                >
                  10234 W Middleburg Loop #152
                </NavDropdown.Item>                                  
                <NavDropdown.Item
                  as={Link}
                  href="/homes-for-sale/Lecanto/843856"
                  aria-label="Commercial Office for sale at 3729 S Lecanto Hwy, Lecanto, FL 34461"
                  title="Commercial Office for sale in Lecanto, FL 34461"
                >
                  3729 S Lecanto Hwy
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  href="/homes-for-sale/Homosassa-Tradewinds-Condos/841532"
                  aria-label="Home for sale at 10209 W Waterlander Loop #164, Homosassa, FL 34448"
                  title="Home for sale in Homosassa Tradewinds Resort"
                >
                  10209 W Waterlander Loop #164
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  href="/homes-for-sale/Homosassa-Tradewinds-Condos/834660"
                  aria-label="Home for sale at 10204 W Waterlander Loop #159, Homosassa, FL 34448"
                  title="Home for sale in Homosassa Tradewinds Resort"
                >
                  10204 W Waterlander Loop #159
                </NavDropdown.Item>   
                <NavDropdown.Item
                  as={Link}
                  href="/homes-for-sale/Moorings-at-Point-O-Woods/848064"
                  aria-label="Home for sale at 76 S Heron Creek Loop, Inverness, FL 34450"
                  title="Home for sale in Moorings at Point O Woods"
                >
                  76 S Heron Creek Loop
                </NavDropdown.Item>     
                <NavDropdown.Item
                  as={Link}
                  href="/homes-for-sale/Citrus-Springs/853024"
                  aria-label="Home for sale at 8623 N Dora Way, Dunnellon, FL 34434"
                  title="Home for sale in Citrus Springs"
                >
                  8623 N Dora Way
                </NavDropdown.Item>               
                {/* PENDINGS */}   
                <NavDropdown.Item
                  as={Link}
                  href="/homes-for-sale/Pine-Ridge/856357"
                  aria-label="Home for sale at 3329 W Danny Ct, Pine Ridge, FL 34465"
                  title="Home for sale in Pine Ridge"
                >
                  3329 W Danny Ct
                </NavDropdown.Item>                                           
                <NavDropdown.Item
                  as={Link}
                  href="/homes-for-sale/Cinnamon-Ridge/856038"
                  aria-label="Home for sale at 5351 W Rolling View Pl, Lecanto, FL 34461"
                  title="Home for sale in Lecanto, FL 34461"
                >
                  5351 W Rolling View Pl
                </NavDropdown.Item>                                    
                <NavDropdown.Item
                  as={Link}
                  href="/homes-for-sale/Pine-Ridge/854802"
                  aria-label="Home for sale at 4525 W Alamo Dr, Pine Ridge, FL 34465"
                  title="Home for sale in Pine Ridge"
                >
                  4525 W Alamo Dr
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  href="/homes-for-sale/Lake-Rousseau/850089"
                  aria-label="Home for sale at 11490 N Wahoo Trl, Dunnellon, FL 34433"
                  title="Home for sale in Lake Rousseau"
                >
                  11490 N Wahoo Trl
                </NavDropdown.Item>                                                                                                                                          
                {/* PENDINGS */}
              </NavDropdown>
              <NavDropdown
                title={<span className="menu-search-label" 
                  aria-label="Propery Search"></span>}
                id="basic-nav-dropdown"
              >
                {/* <NavDropdown.Item
                  as={Link}
                  target="_blank"
                  href="https://exprealty.com/link/ruth_squires/6f64359e/"
                  aria-label="Auction Properties in the US"
                  title="Auction Properties in the US"
                >
                  Auction Properties
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  target="_blank"
                  href="https://exprealty.com/link/ruth_squires/679757a4/"
                  aria-label="Foreclosure Homes in the US"
                  title="Foreclosure Homes in the US"
                >
                  Foreclosure Homes
                </NavDropdown.Item> */}
                <NavDropdown.Item
                  as={Link}
                  target="_blank"
                  href="https://ruthsquires.exprealty.com/"
                  aria-label="Nationwide Homes Search in the US"
                  title="Nationwide Homes Search in the US"
                >
                  Search Homes Nationwide
                </NavDropdown.Item>
              </NavDropdown>
              <NavDropdown
                title={<span className="menu-area-label" 
                  aria-label="Our Area"></span>}
                id="basic-nav-dropdown"
              >
                <NavDropdown.Item
                  as={Link}
                  href="/florida-community/pine-ridge"
                  aria-label="Learn more about Pine Ridge Estates"
                  title="Learn more about Pine Ridge Estates"
                >
                  Pine Ridge
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  href="/florida-community/terra-vista"
                  aria-label="Learn more about Terra Vista"
                  title="Learn more about Terra Vista"
                >
                  Terra Vista
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  href="/florida-community/tradewinds-resort"
                  aria-label="Learn more about TradeWinds Resort"
                  title="Learn more about TradeWinds Resort"
                >
                  TradeWinds Resort
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  href="/homes-for-sale/citrus-hills"
                  aria-label="Home for sale in Citrus Hills"
                  title="Home for sale in Citrus Hills"
                >
                  Citrus Hills
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  href="/florida-community/canterbury-lake-estates"
                  aria-label="Learn more about Canterbury Lake Estates"
                  title="Learn more about Canterbury Lake Estates"
                >
                  Canterbury Lake Estates
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  href="/florida-community/crystal-oaks"
                  aria-label="Learn more about Crystal Oaks"
                  title="Learn more about Crystal Oaks"
                >
                  Crystal Oaks
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  href="/homes-for-sale/citrus-springs"
                  aria-label="Home for sale in Citrus Springs"
                  title="Home for sale in Citrus Springs"
                >
                  Citrus Springs
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  href="/homes-for-sale/meadowcrest"
                  aria-label="Home for sale in Meadowcrest"
                  title="Home for sale in Meadowcrest"
                >
                  Meadowcrest
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  href="/florida-community/moorings-at-point-o-woods"
                  aria-label="Learn more about Moorings at Point O Woods"
                  title="Learn more about Moorings at Point O Woods"
                >
                  Crystal Oaks
                </NavDropdown.Item>                
              </NavDropdown>
              <NavDropdown
                title={<span className="menu-resources-label" 
                  aria-label="Home Buying Resources / Home Selling Resources"></span>}
                id="basic-nav-dropdown"
              >
                <NavDropdown.Item
                  as={Link}
                  href="/real-estate/resources?frm=marketnewsletter"
                  aria-label="Real Estate Newsletter Sign Up"
                  title="Real Estate Newsletter Sign Up"
                >
                  Newsletter Sign Up
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  href="/real-estate/resources?frm=mortgage-calc"
                  aria-label="Mortgage Calculator"
                  title="Mortgage Calculator"
                >
                  Mortgage Calculator
                </NavDropdown.Item>
                {/* <NavDropdown.Item as={Link} href="/real-estate/resources?frm=eventnotification" title="Real Estate Event Notifications" aria-label="Real Estate Event Notifications">
                                    Event Notifications
                                   </NavDropdown.Item> */}
                <NavDropdown.Item
                  as={Link}
                  href="/real-estate/book"
                  aria-label="RES Luxury Group Real Estate Real Estate Book - Selling Secrets"
                  title="RES Luxury Group Real Estate Real Estate Book - Selling Secrets"
                >
                  Our Book
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  href="/real-estate/market-stats"
                  aria-label="Real Estate Market Housing Stats"
                  title="Real Estate Market Housing Stats"
                >
                  Housing Market Stats
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  href="/real-estate/realtor-on-demand"
                  aria-label="RES Luxury Group - Realtor On Demand"
                  title="RES Luxury Group - Realtor On Demand"
                >
                  Realtor On Demand
                </NavDropdown.Item>
                {/* <NavDropdown.Item as={Link} href="/real-estate/best-buy-homes-list" title="Florida Best Buy Homes List" aria-label="Florida Best Buy Homes List">
                                    Best Buy Homes List
                                    </NavDropdown.Item> */}
                <NavDropdown.Item
                  as={Link}
                  href="/real-estate/hometown-heroes"
                  aria-label="Learn more about the Hometown Heroes Program"
                  title="Learn more about the Hometown Heroes Program"
                >
                  Hometown Heroes
                </NavDropdown.Item>
                {/* <NavDropdown.Item as={Link} href="/real-estate/relocation" title="Relocation Resources" aria-label="Relocation Resources">
                                    Relocation Resources
                                    </NavDropdown.Item> */}
                <NavDropdown.Item
                  as={Link}
                  href="/real-estate/vendors"
                  aria-label="RES Luxury Group - Preferred Vendors"
                  title="RES Luxury Group - Preferred Vendors"
                >
                  Preferred Vendors
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  href="/real-estate/resources"
                  aria-label="More Real Estate Resources"
                  title="More Real Estate Resources"
                >
                  More Resources
                </NavDropdown.Item>
              </NavDropdown>
              <NavDropdown
                title={<span className="menu-about-label" 
                  aria-label="About Us"></span>}
                id="basic-nav-dropdown"
              >
                <NavDropdown.Item
                  as={Link}
                  href="/real-estate/reviews"
                  aria-label="RES Luxury Group Customer Reviews"
                  title="RES Luxury Group Customer Reviews"
                >
                  Customer Reviews
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  href="/real-estate/contacts"
                  aria-label="Contact RES Luxury Group"
                  title="Contact RES Luxury Group"
                >
                  Contact Us
                </NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
          <Image
            src={logo}
            alt="eXp Realty"
            className="broker-logo d-inline-block align-top"
          />{" "}
        </Container>
      </Navbar>
      <Modal
        size="lg"
        fullscreen="md-down"
        centered={true}
        show={currentState?.currentModal === "feedback"}
        onHide={() => setModal("")}
      >
        <Modal.Header closeButton>
          <Modal.Title>Your feedback is very important.</Modal.Title>
        </Modal.Header>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Modal.Body>
            <p>Please complete the form below to summarize your experience.</p>
            <Form.Group className="form-floating mb-3" controlId="feedback">
              <Form.Control
                as="textarea"
                placeholder="Enter feedback"
                maxLength={256}
                rows={4}
                value={formValues["feedback"] || ""}
                onChange={handleChange}
                required
              />
              <Form.Label>Enter Feedback (Required)</Form.Label>
              <Form.Control.Feedback type="invalid">
                Please provide feedback.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group
              className="form-floating mb-3 col-md-6"
              controlId="fullname"
            >
              <Form.Control
                type="text"
                placeholder="Full name"
                maxLength={256}
                value={formValues["fullname"] || ""}
                onChange={handleChange}
                required
              />
              <Form.Label>Full Name (Required)</Form.Label>
              <Form.Control.Feedback type="invalid">
                Please provide full name.
              </Form.Control.Feedback>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <div className="me-auto">
              <i role="presentation" className="bi bi-shield-lock-fill"></i> We
              respect your{" "}
              <a
                href="/real-estate/privacy-policy"
                aria-label="RES Luxury Group - Privacy Policy"
                title="RES Luxury Group - Privacy Policy"
                target="_blank"
              >
                privacy
              </a>{" "}
              and will not share or resell your information.
            </div>
            <Button size="lg" variant="blue" type="submit" disabled={isLoading}>
              {isLoading ? (
                <>
                  Saving{" "}
                  <i
                    role="presentation"
                    className="bi bi-cloud-arrow-up-fill"
                  ></i>
                </>
              ) : (
                <>
                  Submit{" "}
                  <i role="presentation" className="bi bi-caret-right-fill"></i>
                </>
              )}
            </Button>         
          </Modal.Footer>
          <input
            type="hidden"
            name="cs"
            id="cs"
            value={formValues["cs"] || 0}
          />
          <input type="hidden" name="ts" id="ts" value={1} />
          <input type="hidden" id="cta" name="cta" value="FeedBack" />
        </Form>
      </Modal>
      <Modal
        size="lg"
        fullscreen="md-down"
        centered={true}
        show={currentState?.currentModal === "video"}
        onHide={() => setModal("")}
      >
        <Modal.Header
          className="bg-black res-font"
          closeVariant="white"
          closeButton
        >
          <div className="res-modal-title">RES Luxury Group</div>
        </Modal.Header>
        <Ratio aspectRatio="16x9">
          <iframe
            className="w-100"
            src={currentState?.modalVideoUrl}
            allowFullScreen
            allow="autoplay"
          ></iframe>
        </Ratio>
      </Modal>
      <Modal
        size="lg"
        fullscreen="md-down"
        centered={true}
        show={currentState?.currentModal === "results"}
        onHide={() => setModal("")}
      >
        <Modal.Header closeButton>{currentState?.resultModal && htmlFrom(currentState?.resultModal?.Header)}</Modal.Header>
        <Modal.Body>{currentState?.resultModal && htmlFrom(currentState?.resultModal?.Body)}</Modal.Body>
        <Modal.Footer>{currentState?.resultModal && htmlFrom(currentState?.resultModal?.Footer)}</Modal.Footer>
      </Modal>
      <Modal
        size="lg"
        fullscreen="md-down"
        centered={true}
        show={currentState?.currentModal === "marketnewsletter"}
        onHide={() => setModal("")}
      >
        <Modal.Header closeButton>
          <Modal.Title>Subscribe to stay up to date!</Modal.Title>
        </Modal.Header>
        <Form
          action="https://mlscitrus.us20.list-manage.com/subscribe/post?u=3b4dbb66e4fc29b28043a871a&amp;id=8da6ad4bc4"
          method="post"
          id="mc-embedded-subscribe-form"
          noValidate
          validated={validated}
          onSubmit={handleSubmit}
        >
          <Modal.Body>
            <p>Please complete the form below to receive our newsletter.</p>
            <Row>
              <Col>
                <Form.Group
                  className="form-floating mb-3"
                  controlId="mce-FNAME"
                >
                  <Form.Control
                    data-type="mce"
                    name="FNAME"
                    type="text"
                    placeholder="First name (Required)"
                    maxLength={256}
                    value={formValues["fname"] || ""}
                    onChange={handleChange}
                    required
                  />
                  <Form.Label>First Name (Required)</Form.Label>
                  <Form.Control.Feedback type="invalid">
                    Please provide first name.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group
                  className="form-floating mb-3"
                  controlId="mce-LNAME"
                >
                  <Form.Control
                    data-type="mce"
                    name="LNAME"
                    type="text"
                    placeholder="Last name (Required)"
                    maxLength={256}
                    value={formValues["lname"] || ""}
                    onChange={handleChange}
                    required
                  />
                  <Form.Label>Last Name (Required)</Form.Label>
                  <Form.Control.Feedback type="invalid">
                    Please provide last name.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm="9">
                <Form.Group
                  className="form-floating mb-3"
                  controlId="mce-EMAIL"
                >
                  <Form.Control
                    data-type="mce"
                    name="EMAIL"
                    type="email"
                    placeholder="Email (Required)"
                    maxLength={256}
                    value={formValues["email"] || ""}
                    onChange={handleChange}
                    required
                  />
                  <Form.Label>Email (Required)</Form.Label>
                  <Form.Control.Feedback type="invalid">
                    Please provide email address.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col sm="3">
                <Form.Group
                  className="form-floating mb-3"
                  controlId="mobile"
                >
                  <Form.Control
                    data-type="mce-phone"
                    type="tel"
                    placeholder="Mobile (Required)"
                    value={formValues["mobile"] || ""}
                    onChange={handleChange}
                    pattern="^\d{3}-?\d{3}-?\d{4}$"
                    required
                  />
                  <Form.Label>Mobile (Required)</Form.Label>
                  <Form.Control.Feedback type="invalid">
                    Please provide mobile phone number.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <div className="me-auto">
              <i role="presentation" className="bi bi-shield-lock-fill"></i> We
              respect your{" "}
              <a
                href="/real-estate/privacy-policy"
                aria-label="RES Luxury Group - Privacy Policy"
                title="RES Luxury Group - Privacy Policy"
                target="_blank"
              >
                privacy
              </a>{" "}
              and will not share or resell your information.
            </div>
            <Button
              size="lg"
              variant="blue"
              type="submit"
              disabled={isLoading}
              id="mc-embedded-subscribe"
            >
              {isLoading ? (
                <>
                  Saving{" "}
                  <i
                    role="presentation"
                    className="bi bi-cloud-arrow-up-fill"
                  ></i>
                </>
              ) : (
                <>
                  Subscribe{" "}
                  <i role="presentation" className="bi bi-caret-right-fill"></i>
                </>
              )}
            </Button>
          </Modal.Footer>
          <input
            id="mce-PHONE-area"
            name="PHONE[area]"
            value={formValues["phone-area"]}
            type="hidden"
          />
          <input
            id="mce-PHONE-detail1"
            name="PHONE[detail1]"
            value={formValues["phone-detail1"]}
            type="hidden"
          />
          <input
            id="mce-PHONE-detail2"
            name="PHONE[detail2]"
            value={formValues["phone-detail2"]}
            type="hidden"
          />
          <input
            type="hidden"
            name="b_3b4dbb66e4fc29b28043a871a_8da6ad4bc4"
            value=""
          />
          <input
            type="hidden"
            name="cs"
            id="cs"
            value={formValues["cs"] || 0}
          />
          <input type="hidden" name="ts" id="ts" value={1} />
          <input type="hidden" id="cta" name="cta" value="MarketNewsletter" />
        </Form>
      </Modal>
      {/* Multi-part Forms */}
      <Modal
        size="lg"
        fullscreen="md-down"
        centered={true}
        show={currentState?.currentModal === "mortgage-calc"}
        onHide={() => setModal("")}
      >
        <Modal.Header closeButton>
          <Modal.Title>Find out how much you can afford now!</Modal.Title>
        </Modal.Header>
        <Form
          noValidate
          validated={validated}
          onSubmit={handleSubmit}
          ref={formCalc}
        >
          <Modal.Body>
            <div className={formValues["cs"] < 1 ? "" : "d-none"}>
              <p>
                Please complete the form below to gain instant access to our
                realtime mortgage calculator.
              </p>
              {MainForm()}
            </div>
            <div className={formValues["cs"] == 1 ? "" : "d-none"}>
              <p>
                Use this mortgage calculator to figure out what kind of house
                you can afford. There are two ways to use this calculator:
              </p>
              <p>
                1. Enter the amount of a mortgage in the "Mortgage Amount" field
                and click on the "Calculate Payment" button to determine the
                monthly payments for the home.
              </p>
              <p>
                2. Enter the amount of monthly payment you want to pay in the
                "Monthly Payments" field and click on the "Calculate Mortgage"
                button to determine the mortgage you can afford.
              </p>
              <Row>
                <Col>
                  <Form.Group
                    className="form-floating mb-3"
                    controlId="amount"
                  >
                    <Form.Control
                      type="text"
                      placeholder="Mortgage Amount"
                      value={formValues["amount"] || ""}
                      onChange={handleChange}
                      pattern="^\$?[0-9]{1,3}(?:,?[0-9]{3})*(?:\.[0-9]{2})?$"
                      required={formValues["cs"] == 1}
                    />
                    <Form.Label>Mortgage Amount</Form.Label>
                    <Form.Control.Feedback type="invalid">
                      Please provide valid mortgage amount to the nearest cent.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group
                    className="form-floating mb-3"
                    controlId="payments"
                  >
                    <Form.Control
                      type="text"
                      placeholder="Length of Term"
                      value={formValues["payments"] || ""}
                      onChange={handleChange}
                      pattern="^\$?[0-9]{1,3}(?:,?[0-9]{3})*(?:\.[0-9]{2})?$"
                      required={formValues["cs"] == 1}
                    />
                    <Form.Label>Estimated Monthly Payments</Form.Label>
                    <Form.Control.Feedback type="invalid">
                      Please provide valid monthly payments to the nearest cent.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    className="form-floating mb-3"
                    controlId="rate"
                  >
                    <Form.Control
                      type="text"
                      placeholder="Interest Rate (Required)"
                      maxLength={8}
                      value={formValues["rate"] || ""}
                      onChange={handleChange}
                      pattern="^(([0-9]*)|(([0-9]*)\.([0-9]*)))$"
                      required={formValues["cs"] == 1}
                    />
                    <Form.Label>Interest Rate</Form.Label>
                    <Form.Control.Feedback type="invalid">
                      Please provide valid interest rate.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group
                    className="form-floating mb-3"
                    controlId="term"
                  >
                    <Form.Control
                      type="text"
                      placeholder="Length of Term (Required)"
                      maxLength={8}
                      value={formValues["term"] || ""}
                      onChange={handleChange}
                      pattern="^(([0-9]*)|(([0-9]*)\.([0-9]*)))$"
                      required={formValues["cs"] == 1}
                    />
                    <Form.Label>Length of Term (years)</Form.Label>
                    <Form.Control.Feedback type="invalid">
                      Please provide valid length of term in years.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className={formValues["cs"] < 1 ? "" : "d-none"}>
              <Stack gap={2} direction="horizontal">
                <div className="me-auto">
                  <i role="presentation" className="bi bi-shield-lock-fill"></i>{" "}
                  We respect your{" "}
                  <a
                    href="/real-estate/privacy-policy"
                    aria-label="RES Luxury Group - Privacy Policy"
                    title="RES Luxury Group - Privacy Policy"
                    target="_blank"
                  >
                    privacy
                  </a>{" "}
                  and will not share or resell your information.
                </div>
                <Button
                  size="lg"
                  variant="blue"
                  type="submit"
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <>
                      Saving{" "}
                      <i
                        role="presentation"
                        className="bi bi-cloud-arrow-up-fill"
                      ></i>
                    </>
                  ) : (
                    <>
                      {formValues["cs"] < 1
                        ? "Get Access Now"
                        : formValues["cs"] < 2
                        ? "Next"
                        : "Submit"}{" "}
                      <i
                        role="presentation"
                        className="bi bi-caret-right-fill"
                      ></i>
                    </>
                  )}
                </Button>
              </Stack>
            </div>
            <div className={formValues["cs"] == 1 ? "" : "d-none"}>
              <Stack gap={2} direction="horizontal">
                <Button
                  size="lg"
                  variant="blue"
                  type="button"
                  onClick={() => CalcMortgage("payment")}
                >
                  <>
                    Calculate Payment{" "}
                    <i role="presentation" className="bi bi-calculator"></i>
                  </>
                </Button>
                <Button
                  size="lg"
                  variant="blue"
                  type="button"
                  onClick={() => CalcMortgage("amount")}
                >
                  <>
                    Calculate Mortgage{" "}
                    <i role="presentation" className="bi bi-calculator"></i>
                  </>
                </Button>
                <Button
                  size="lg"
                  variant="secondary"
                  type="button"
                  onClick={() => CalcMortgage("reset")}
                >
                  <>
                    Reset <i role="presentation" className="bi bi-x-square"></i>
                  </>
                </Button>
              </Stack>
            </div>
          </Modal.Footer>
          <input
            type="hidden"
            name="cs"
            id="cs"
            value={formValues["cs"] || 0}
          />
          <input type="hidden" name="ts" id="ts" value={1} />
          <input type="hidden" id="cta" name="cta" value="mortgage-calc" />
        </Form>
      </Modal>
      <Modal
        size="lg"
        fullscreen="md-down"
        centered={true}
        show={currentState?.currentModal === "justsold"}
        onHide={() => setModal("")}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            FREE report of ALL “Just Sold” homes in YOUR neighborhood!
          </Modal.Title>
        </Modal.Header>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Modal.Body>
            <div className={formValues["cs"] < 1 ? "" : "d-none"}>
              <p>
                Please complete the form below to gain access to your FREE “Just
                Sold” report.
              </p>
              <Row>
                <Col>
                  <Form.Group
                    className="form-floating mb-3"
                    controlId="neighborhood"
                  >
                    <Form.Control
                      type="text"
                      placeholder="Neighborhood/subdivision (Required)"
                      maxLength={256}
                      value={formValues["neighborhood"] || ""}
                      onChange={handleChange}
                      required={formValues["cs"] < 1}
                    />
                    <Form.Label>Neighborhood/subdivision (Required)</Form.Label>
                    <Form.Control.Feedback type="invalid">
                      Please provide neighborhood/subdivision.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col sm="9">
                  <Form.Group className="form-floating mb-3" controlId="email">
                    <Form.Control
                      type="email"
                      placeholder="Email (Required)"
                      maxLength={256}
                      value={formValues["email"] || ""}
                      onChange={handleChange}
                      required={formValues["cs"] < 1}
                    />
                    <Form.Label>Email (Required)</Form.Label>
                    <Form.Control.Feedback type="invalid">
                      Please provide email address.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
            </div>
            <div className={formValues["cs"] == 1 ? "" : "d-none"}>
              <p>Are you currently working with a Realtor?</p>
              <Row>
                <Col>
                  <Form.Group
                    className="form-floating mb-3"
                    controlId="realtor"
                  >
                    <Form.Select
                      aria-label="Select realtor status"
                      value={formValues["realtor"] || ""}
                      onChange={handleChange}
                      required={formValues["cs"] == 1}
                    >
                      <option value=""></option>
                      <option value="Y">Yes, I have a realtor</option>
                      <option value="N">No, I do not have a realtor</option>
                    </Form.Select>
                    <Form.Label>Select realtor status</Form.Label>
                    <Form.Control.Feedback type="invalid">
                      Please select realtor status.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
            </div>
            <div className={formValues["cs"] == 2 ? "" : "d-none"}>
              <p>What is your current situation?</p>
              <Row>
                <Col>
                  <Form.Group
                    className="form-floating mb-3"
                    controlId="situation"
                  >
                    <Form.Select
                      aria-label="Select situation"
                      value={formValues["situation"] || ""}
                      onChange={handleChange}
                      required={formValues["cs"] == 2}
                    >
                      <option value=""></option>
                      <option value="SELL">Need to sell my home</option>
                      <option value="BUY">Need to buy a home</option>
                      <option value="BOTH">Need to sell and buy</option>
                    </Form.Select>
                    <Form.Label>Select situation</Form.Label>
                    <Form.Control.Feedback type="invalid">
                      Please select situation.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
            </div>
            <div className={formValues["cs"] == 3 ? "" : "d-none"}>
              <p>When are you thinking of selling or buying?</p>
              <Row>
                <Col>
                  <Form.Group
                    className="form-floating mb-3"
                    controlId="timeframe"
                  >
                    <Form.Select
                      aria-label="Select timeframe"
                      value={formValues["timeframe"] || ""}
                      onChange={handleChange}
                      required={formValues["cs"] == 3}
                    >
                      <option value=""></option>
                      <option value="0-30">0-30 days</option>
                      <option value="31-90">31-90 days</option>
                      <option value="180+">Over 6 months</option>
                      <option value="THINKING">
                        Just in the "thinking about it" stage right now
                      </option>
                    </Form.Select>
                    <Form.Label>Select timeframe</Form.Label>
                    <Form.Control.Feedback type="invalid">
                      Please select situation.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
            </div>
            <div className={formValues["cs"] == 4 ? "" : "d-none"}>
              <p>
                If you"d like a detailed report about the current value of your
                property, enter the address here. (Optional but recommended)
              </p>
              <Row>
                <Col>
                  <Form.Group
                    className="form-floating mb-3"
                    controlId="address"
                  >
                    <Form.Control
                      type="text"
                      placeholder="Property Address"
                      maxLength={256}
                      value={formValues["address"] || ""}
                      onChange={handleChange}
                    />
                    <Form.Label>Property Address</Form.Label>
                  </Form.Group>
                </Col>
              </Row>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="me-auto">
              <i role="presentation" className="bi bi-shield-lock-fill"></i> We
              respect your{" "}
              <a
                href="/real-estate/privacy-policy"
                aria-label="RES Luxury Group - Privacy Policy"
                title="RES Luxury Group - Privacy Policy"
                target="_blank"
              >
                privacy
              </a>{" "}
              and will not share or resell your information.
            </div>
            <Button size="lg" variant="blue" type="submit" disabled={isLoading}>
              {isLoading ? (
                <>
                  Saving{" "}
                  <i
                    role="presentation"
                    className="bi bi-cloud-arrow-up-fill"
                  ></i>
                </>
              ) : (
                <>
                  {formValues["cs"] < 1
                    ? "Get Access Now"
                    : formValues["cs"] < 4
                    ? "Next"
                    : "Submit"}{" "}
                  <i role="presentation" className="bi bi-caret-right-fill"></i>
                </>
              )}
            </Button>
          </Modal.Footer>
          <input
            type="hidden"
            name="cs"
            id="cs"
            value={formValues["cs"] || 0}
          />
          <input type="hidden" name="ts" id="ts" value={5} />
          <input
            type="hidden"
            id="sto"
            name="sto"
            value={formValues["situation"] === "SELL" ? "ruthlead" : "leadpool"}
          />
          <input type="hidden" id="cta" name="cta" value="JustSold" />
        </Form>
      </Modal>
      {/* Basic Forms */}
      <Modal
        size="lg"
        fullscreen="md-down"
        centered={true}
        show={currentState?.currentModal === "closingvoucher"}
        onHide={() => setModal("")}
      >
        <Modal.Header closeButton>
          <Modal.Title>$500 Coupon</Modal.Title>
        </Modal.Header>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Modal.Body>
            <p>Please complete the form below to receive your voucher.</p>
            {MainForm()}
          </Modal.Body>
          <Modal.Footer>
            <div className="me-auto">
              <i role="presentation" className="bi bi-shield-lock-fill"></i> We
              respect your{" "}
              <a
                href="/real-estate/privacy-policy"
                aria-label="RES Luxury Group - Privacy Policy"
                title="RES Luxury Group - Privacy Policy"
                target="_blank"
              >
                privacy
              </a>{" "}
              and will not share or resell your information.
            </div>
            <Button size="lg" variant="blue" type="submit" disabled={isLoading}>
              {isLoading ? (
                <>
                  Saving{" "}
                  <i
                    role="presentation"
                    className="bi bi-cloud-arrow-up-fill"
                  ></i>
                </>
              ) : (
                <>
                  Request Voucher{" "}
                  <i role="presentation" className="bi bi-caret-right-fill"></i>
                </>
              )}
            </Button>
          </Modal.Footer>
          <input
            type="hidden"
            name="cs"
            id="cs"
            value={formValues["cs"] || 0}
          />
          <input type="hidden" name="ts" id="ts" value={1} />
          <input type="hidden" id="cta" name="cta" value="ClosingVoucher" />
        </Form>
      </Modal>
      <Modal
        size="lg"
        fullscreen="md-down"
        centered={true}
        show={currentState?.currentModal === "eventnotification"}
        onHide={() => setModal("")}
      >
        <Modal.Header closeButton>
          <Modal.Title>Stay informed of upcoming events!</Modal.Title>
        </Modal.Header>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Modal.Body>
            <p>
              Please complete the form below to receive notification of upcoming
              events.
            </p>
            {MainForm()}
          </Modal.Body>
          <Modal.Footer>
            <div className="me-auto">
              <i role="presentation" className="bi bi-shield-lock-fill"></i> We
              respect your{" "}
              <a
                href="/real-estate/privacy-policy"
                aria-label="RES Luxury Group - Privacy Policy"
                title="RES Luxury Group - Privacy Policy"
                target="_blank"
              >
                privacy
              </a>{" "}
              and will not share or resell your information.
            </div>
            <Button size="lg" variant="blue" type="submit" disabled={isLoading}>
              {isLoading ? (
                <>
                  Saving{" "}
                  <i
                    role="presentation"
                    className="bi bi-cloud-arrow-up-fill"
                  ></i>
                </>
              ) : (
                <>
                  Get Events{" "}
                  <i role="presentation" className="bi bi-caret-right-fill"></i>
                </>
              )}
            </Button>
          </Modal.Footer>
          <input
            type="hidden"
            name="cs"
            id="cs"
            value={formValues["cs"] || 0}
          />
          <input type="hidden" name="ts" id="ts" value={1} />
          <input type="hidden" id="cta" name="cta" value="EventNotification" />
        </Form>
      </Modal>
      <Modal
        size="lg"
        fullscreen="md-down"
        centered={true}
        show={currentState?.currentModal === "freebook"}
        onHide={() => setModal("")}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Request free access to our book:
            <br />
            <i>"Selling Secrets You Can"t Afford to Miss"</i>
          </Modal.Title>
        </Modal.Header>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Modal.Body>
            <p>Please complete the form below to gain access to our book.</p>
            {MainForm()}
          </Modal.Body>
          <Modal.Footer>
            <div className="me-auto">
              <i role="presentation" className="bi bi-shield-lock-fill"></i> We
              respect your{" "}
              <a
                href="/real-estate/privacy-policy"
                aria-label="RES Luxury Group - Privacy Policy"
                title="RES Luxury Group - Privacy Policy"
                target="_blank"
              >
                privacy
              </a>{" "}
              and will not share or resell your information.
            </div>
            <Button size="lg" variant="blue" type="submit" disabled={isLoading}>
              {isLoading ? (
                <>
                  Saving{" "}
                  <i
                    role="presentation"
                    className="bi bi-cloud-arrow-up-fill"
                  ></i>
                </>
              ) : (
                <>
                  Get Access{" "}
                  <i role="presentation" className="bi bi-caret-right-fill"></i>
                </>
              )}
            </Button>
          </Modal.Footer>
          <input
            type="hidden"
            name="cs"
            id="cs"
            value={formValues["cs"] || 0}
          />
          <input type="hidden" name="ts" id="ts" value={1} />
          <input type="hidden" id="cta" name="cta" value="FreeBook" />
        </Form>
      </Modal>
      <Modal
        size="lg"
        fullscreen="md-down"
        centered={true}
        show={currentState?.currentModal === "ratesvideo"}
        onHide={() => setModal("")}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Request free access to how people can get 2-3% Mortgage Rates
          </Modal.Title>
        </Modal.Header>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Modal.Body>
            <p>
              Please complete the form below to gain access to low mortgage rate
              secrets.
            </p>
            {MainForm()}
          </Modal.Body>
          <Modal.Footer>
            <div className="me-auto">
              <i role="presentation" className="bi bi-shield-lock-fill"></i> We
              respect your{" "}
              <a
                href="/real-estate/privacy-policy"
                aria-label="RES Luxury Group - Privacy Policy"
                title="RES Luxury Group - Privacy Policy"
                target="_blank"
              >
                privacy
              </a>{" "}
              and will not share or resell your information.
            </div>
            <Button size="lg" variant="blue" type="submit" disabled={isLoading}>
              {isLoading ? (
                <>
                  Saving{" "}
                  <i
                    role="presentation"
                    className="bi bi-cloud-arrow-up-fill"
                  ></i>
                </>
              ) : (
                <>
                  Get Access{" "}
                  <i role="presentation" className="bi bi-caret-right-fill"></i>
                </>
              )}
            </Button>
          </Modal.Footer>
          <input
            type="hidden"
            name="cs"
            id="cs"
            value={formValues["cs"] || 0}
          />
          <input type="hidden" name="ts" id="ts" value={1} />
          <input type="hidden" id="cta" name="cta" value="RatesVideo" />
        </Form>
      </Modal>
      <Modal
        size="lg"
        fullscreen="md-down"
        centered={true}
        show={currentState?.currentModal === "bestbuylist"}
        onHide={() => setModal("")}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            RES Luxury Group - Real Estate Best Buy List
          </Modal.Title>
        </Modal.Header>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Modal.Body>
            <p>
              Stay informed of all homes for sale that are listed for $75 per
              sq. ft or less.
            </p>
            {MainForm()}
          </Modal.Body>
          <Modal.Footer>
            <div className="me-auto">
              <i role="presentation" className="bi bi-shield-lock-fill"></i> We
              respect your{" "}
              <a
                href="/real-estate/privacy-policy"
                aria-label="RES Luxury Group - Privacy Policy"
                title="RES Luxury Group - Privacy Policy"
                target="_blank"
              >
                privacy
              </a>{" "}
              and will not share or resell your information.
            </div>
            <Button size="lg" variant="blue" type="submit" disabled={isLoading}>
              {isLoading ? (
                <>
                  Saving{" "}
                  <i
                    role="presentation"
                    className="bi bi-cloud-arrow-up-fill"
                  ></i>
                </>
              ) : (
                <>
                  Get Info{" "}
                  <i role="presentation" className="bi bi-caret-right-fill"></i>
                </>
              )}
            </Button>
          </Modal.Footer>
          <input
            type="hidden"
            name="cs"
            id="cs"
            value={formValues["cs"] || 0}
          />
          <input type="hidden" name="ts" id="ts" value={1} />
          <input type="hidden" id="cta" name="cta" value="BestBuyList" />
        </Form>
      </Modal>
      <Modal
        size="lg"
        fullscreen="md-down"
        centered={true}
        show={currentState?.currentModal === "hth-access"}
        onHide={() => setModal("")}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Request free access to our Hometown Heroes program details
          </Modal.Title>
        </Modal.Header>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Modal.Body>{MainForm()}</Modal.Body>
          <Modal.Footer>
            <div className="me-auto">
              <i role="presentation" className="bi bi-shield-lock-fill"></i> We
              respect your{" "}
              <a
                href="/real-estate/privacy-policy"
                aria-label="RES Luxury Group - Privacy Policy"
                title="RES Luxury Group - Privacy Policy"
                target="_blank"
              >
                privacy
              </a>{" "}
              and will not share or resell your information.
            </div>
            <Button size="lg" variant="blue" type="submit" disabled={isLoading}>
              {isLoading ? (
                <>
                  Saving{" "}
                  <i
                    role="presentation"
                    className="bi bi-cloud-arrow-up-fill"
                  ></i>
                </>
              ) : (
                <>
                  Get Accesss{" "}
                  <i role="presentation" className="bi bi-caret-right-fill"></i>
                </>
              )}
            </Button>
          </Modal.Footer>
          <input
            type="hidden"
            name="cs"
            id="cs"
            value={formValues["cs"] || 0}
          />
          <input type="hidden" name="ts" id="ts" value={1} />
          <input type="hidden" id="cta" name="cta" value="HTH" />
        </Form>
      </Modal>
      <Modal
        size="lg"
        fullscreen="md-down"
        centered={true}
        show={currentState?.currentModal === "hth-qa"}
        onHide={() => setModal("")}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Register for a free Hometown Heroes program Q&amp;A consult
          </Modal.Title>
        </Modal.Header>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Modal.Body>{MainForm()}</Modal.Body>
          <Modal.Footer>
            <div className="me-auto">
              <i role="presentation" className="bi bi-shield-lock-fill"></i> We
              respect your{" "}
              <a
                href="/real-estate/privacy-policy"
                aria-label="RES Luxury Group - Privacy Policy"
                title="RES Luxury Group - Privacy Policy"
                target="_blank"
              >
                privacy
              </a>{" "}
              and will not share or resell your information.
            </div>
            <Button size="lg" variant="blue" type="submit" disabled={isLoading}>
              {isLoading ? (
                <>
                  Saving{" "}
                  <i
                    role="presentation"
                    className="bi bi-cloud-arrow-up-fill"
                  ></i>
                </>
              ) : (
                <>
                  Register Now{" "}
                  <i role="presentation" className="bi bi-caret-right-fill"></i>
                </>
              )}
            </Button>
          </Modal.Footer>
          <input
            type="hidden"
            name="cs"
            id="cs"
            value={formValues["cs"] || 0}
          />
          <input type="hidden" name="ts" id="ts" value={1} />
          <input type="hidden" id="cta" name="cta" value="HTH-QA" />
        </Form>
      </Modal>
      <Modal
        size="lg"
        fullscreen="md-down"
        centered={true}
        show={currentState?.currentModal === "tradewinds-rsvp"}
        onHide={() => setModal("")}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Please accept my RSVP to the TradeWinds Community Tour and keep me
            updated!
          </Modal.Title>
        </Modal.Header>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Modal.Body>{MainForm()}</Modal.Body>
          <Modal.Footer>
            <div className="me-auto">
              <i role="presentation" className="bi bi-shield-lock-fill"></i> We
              respect your{" "}
              <a
                href="/real-estate/privacy-policy"
                aria-label="RES Luxury Group - Privacy Policy"
                title="RES Luxury Group - Privacy Policy"
                target="_blank"
              >
                privacy
              </a>{" "}
              and will not share or resell your information.
            </div>
            <Button size="lg" variant="blue" type="submit" disabled={isLoading}>
              {isLoading ? (
                <>
                  Saving{" "}
                  <i
                    role="presentation"
                    className="bi bi-cloud-arrow-up-fill"
                  ></i>
                </>
              ) : (
                <>
                  Register Now{" "}
                  <i role="presentation" className="bi bi-caret-right-fill"></i>
                </>
              )}
            </Button>
          </Modal.Footer>
          <input
            type="hidden"
            id="neighborhood"
            name="neighborhood"
            value="TradeWinds-Resort"
          />
          <input
            type="hidden"
            name="cs"
            id="cs"
            value={formValues["cs"] || 0}
          />
          <input type="hidden" name="ts" id="ts" value={1} />
          <input type="hidden" id="cta" name="cta" value="TradeWinds-RSVP" />
          <input type="hidden" id="sto" name="sto" value="admin" />
        </Form>
      </Modal>
      <Modal
        size="lg"
        fullscreen="md-down"
        centered={true}
        show={currentState?.currentModal === "chbuildershowcasehomes"}
        onHide={() => setModal("")}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            RES Luxury Group - Off-market showcase homes
          </Modal.Title>
        </Modal.Header>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Modal.Body>
            <p>
              Feel free to complete the form below to request your exclusive
              list of off-market Terra Vista homes.
            </p>
            {MainForm()}
          </Modal.Body>
          <Modal.Footer>
            <div className="me-auto">
              <i role="presentation" className="bi bi-shield-lock-fill"></i> We
              respect your{" "}
              <a
                href="/real-estate/privacy-policy"
                aria-label="RES Luxury Group - Privacy Policy"
                title="RES Luxury Group - Privacy Policy"
                target="_blank"
              >
                privacy
              </a>{" "}
              and will not share or resell your information.
            </div>
            <Button size="lg" variant="blue" type="submit" disabled={isLoading}>
              {isLoading ? (
                <>
                  Saving{" "}
                  <i
                    role="presentation"
                    className="bi bi-cloud-arrow-up-fill"
                  ></i>
                </>
              ) : (
                <>
                  Request Access{" "}
                  <i role="presentation" className="bi bi-caret-right-fill"></i>
                </>
              )}
            </Button>
          </Modal.Footer>
          <input
            type="hidden"
            name="cs"
            id="cs"
            value={formValues["cs"] || 0}
          />
          <input type="hidden" name="ts" id="ts" value={1} />
          <input
            type="hidden"
            id="cta"
            name="cta"
            value="CHBuilderShowcaseHomes"
          />
        </Form>
      </Modal>
      {/* Basic Forms + Additional field */}
      <Modal
        size="lg"
        fullscreen="md-down"
        centered={true}
        show={currentState?.currentModal === "homeslist"}
        onHide={() => setModal("")}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Homes for sale{currentState?.subdivision ? ` in ${currentState?.subdivision}` : ` list`}
          </Modal.Title>
        </Modal.Header>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Modal.Body>
            <p>
              Please complete the form below to request your FREE list of{" "}
              {currentState?.subdivision} homes for sale.
            </p>
            {MainForm()}
            <Row>
              <Col>
                <Form.Group
                  className="form-floating mb-3"
                  controlId="neighborhood"
                >
                  <Form.Control
                    type="text"
                    placeholder="Subdivision (Required)"
                    maxLength={256}
                    value={formValues["neighborhood"] || `${currentState?.subdivision}`}
                    onChange={handleChange}
                    required
                  />
                  <Form.Label>Subdivision (Required)</Form.Label>
                  <Form.Control.Feedback type="invalid">
                    Please provide the subdivision that you wish to receive
                    listings on.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <div className="me-auto">
              <i role="presentation" className="bi bi-shield-lock-fill"></i> We
              respect your{" "}
              <a
                href="/real-estate/privacy-policy"
                aria-label="RES Luxury Group - Privacy Policy"
                title="RES Luxury Group - Privacy Policy"
                target="_blank"
              >
                privacy
              </a>{" "}
              and will not share or resell your information.
            </div>
            <Button size="lg" variant="blue" type="submit" disabled={isLoading}>
              {isLoading ? (
                <>
                  Saving{" "}
                  <i
                    role="presentation"
                    className="bi bi-cloud-arrow-up-fill"
                  ></i>
                </>
              ) : (
                <>
                  Get List Now{" "}
                  <i role="presentation" className="bi bi-caret-right-fill"></i>
                </>
              )}
            </Button>
          </Modal.Footer>
          <input
            type="hidden"
            name="cs"
            id="cs"
            value={formValues["cs"] || 0}
          />
          <input type="hidden" name="ts" id="ts" value={1} />
          <input type="hidden" id="cta" name="cta" value="HomesList" />
        </Form>
      </Modal>
      <Modal
        size="lg"
        fullscreen="md-down"
        centered={true}
        show={currentState?.currentModal === "speciallist"}
      >
        <Modal.Header>
          <Modal.Title>
            Special{" "}
            {currentState?.subdivision ? ` ${currentState?.subdivision} property list` : ` property list`}
          </Modal.Title>
        </Modal.Header>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Modal.Body>
            <p>
              Please complete the form below to be granted access to your FREE{" "}
              {currentState?.subdivision} list of homes for sale.
            </p>
            {MainForm()}
            <Row>
              <Col>
                <Form.Group
                  className="form-floating mb-3"
                  controlId="neighborhood"
                >
                  <Form.Control
                    type="text"
                    placeholder="Property Type (Required)"
                    maxLength={256}
                    value={
                      formValues["neighborhood"]
                        ? formValues["neighborhood"]
                        : currentState?.subdivision
                    }
                    onChange={handleChange}
                    required
                    readOnly
                  />
                  <Form.Label>Property Type (Required)</Form.Label>
                  <Form.Control.Feedback type="invalid">
                    Please provide the subdivision that you wish to receive
                    listings on.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <div className="me-auto">
              <i role="presentation" className="bi bi-shield-lock-fill"></i> We
              respect your{" "}
              <a
                href="/real-estate/privacy-policy"
                aria-label="RES Luxury Group - Privacy Policy"
                title="RES Luxury Group - Privacy Policy"
                target="_blank"
              >
                privacy
              </a>{" "}
              and will not share or resell your information.
            </div>
            <Button size="lg" variant="blue" type="submit" disabled={isLoading}>
              {isLoading ? (
                <>
                  Saving{" "}
                  <i
                    role="presentation"
                    className="bi bi-cloud-arrow-up-fill"
                  ></i>
                </>
              ) : (
                <>
                  Get List Now{" "}
                  <i role="presentation" className="bi bi-caret-right-fill"></i>
                </>
              )}
            </Button>
          </Modal.Footer>
          <input
            type="hidden"
            name="cs"
            id="cs"
            value={formValues["cs"] || 0}
          />
          <input type="hidden" name="ts" id="ts" value={1} />
          <input type="hidden" id="cta" name="cta" value="SpecialList" />
        </Form>
      </Modal>
      <Modal
        size="lg"
        fullscreen="md-down"
        centered={true}
        show={currentState?.currentModal === "offmarket-terravista"}
        onHide={() => setModal("")}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Enjoy browsing our Terra Vista community resource page.
          </Modal.Title>
        </Modal.Header>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Modal.Body>
            <p>
              Feel free to complete the form below to request your exclusive
              list of off-market Terra Vista homes.
            </p>
            {MainForm()}
            <Row>
              <Col>
                <Form.Group
                  className="form-floating mb-3"
                  controlId="neighborhood"
                >
                  <Form.Control
                    type="text"
                    placeholder="Subdivision (Required)"
                    maxLength={256}
                    value={
                        currentState?.subdivision
                        ? `${currentState?.subdivision}`
                        : "Citrus Hills - Terra Vista"
                    }
                    onChange={handleChange}
                    required
                  />
                  <Form.Label>Subdivision (Required)</Form.Label>
                  <Form.Control.Feedback type="invalid">
                    Please provide the subdivision that you wish to receive
                    listings on.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <div className="me-auto">
              <i role="presentation" className="bi bi-shield-lock-fill"></i> We
              respect your{" "}
              <a
                href="/real-estate/privacy-policy"
                aria-label="RES Luxury Group - Privacy Policy"
                title="RES Luxury Group - Privacy Policy"
                target="_blank"
              >
                privacy
              </a>{" "}
              and will not share or resell your information.
            </div>
            <Button size="lg" variant="blue" type="submit" disabled={isLoading}>
              {isLoading ? (
                <>
                  Saving{" "}
                  <i
                    role="presentation"
                    className="bi bi-cloud-arrow-up-fill"
                  ></i>
                </>
              ) : (
                <>
                  Get List Now{" "}
                  <i role="presentation" className="bi bi-caret-right-fill"></i>
                </>
              )}
            </Button>
          </Modal.Footer>
          <input
            type="hidden"
            name="cs"
            id="cs"
            value={formValues["cs"] || 0}
          />
          <input type="hidden" name="ts" id="ts" value={1} />
          <input
            type="hidden"
            id="cta"
            name="cta"
            value="offmarket-TerraVista"
          />
        </Form>
      </Modal>
      <Modal
        size="lg"
        fullscreen="md-down"
        centered={true}
        show={currentState?.currentModal === "cashinvestor"}
        onHide={() => setModal("")}
      >
        <Modal.Header closeButton>
          <Modal.Title>Sell your house for CASH NOW!</Modal.Title>
        </Modal.Header>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Modal.Body>
            <p>
              We have cash investors looking for homes today... Interested?
              <br />
              Complete this form and we will reach out to discuss your specific
              needs.
              <br />
              Also feel free to call or text RES Luxury Group, eXp Realty:{" "}
              <a
                href="wtai://wp/mc;3527941426;RES Luxury Group"
                aria-label="Click to automatically dial from mobile device"
                title="Click to automatically dial from mobile device"
              >
                352.794.1426
              </a>
              .
            </p>
            <Row>
              <Col>
                <Form.Group
                  className="form-floating mb-3"
                  controlId="address"
                >
                  <Form.Control
                    type="text"
                    placeholder="Property Address (Required)"
                    maxLength={256}
                    value={formValues["address"] || ""}
                    onChange={handleChange}
                    required
                  />
                  <Form.Label>Property Address (Required)</Form.Label>
                  <Form.Control.Feedback type="invalid">
                    Please provide property address.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            {MainForm()}
          </Modal.Body>
          <Modal.Footer>
            <div className="me-auto">
              <i role="presentation" className="bi bi-shield-lock-fill"></i> We
              respect your{" "}
              <a
                href="/real-estate/privacy-policy"
                aria-label="RES Luxury Group - Privacy Policy"
                title="RES Luxury Group - Privacy Policy"
                target="_blank"
              >
                privacy
              </a>{" "}
              and will not
              <p className="indent">&nbsp;share or resell your information.</p>
            </div>
            <Button size="lg" variant="blue" type="submit" disabled={isLoading}>
              {isLoading ? (
                <>
                  Saving{" "}
                  <i
                    role="presentation"
                    className="bi bi-cloud-arrow-up-fill"
                  ></i>
                </>
              ) : (
                <>
                  Contact me about cash buyers{" "}
                  <i role="presentation" className="bi bi-caret-right-fill"></i>
                </>
              )}
            </Button>
          </Modal.Footer>
          <input
            type="hidden"
            name="cs"
            id="cs"
            value={formValues["cs"] || 0}
          />
          <input type="hidden" name="ts" id="ts" value={1} />
          <input type="hidden" id="sto" name="sto" value="ruthlead" />
          <input type="hidden" id="cta" name="cta" value="CashInvestor" />
        </Form>
      </Modal>
      <Modal
        size="lg"
        fullscreen="md-down"
        centered={true}
        show={currentState?.currentModal === "propertyanalysis"}
        onHide={() => setModal("")}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            YES, analyze my{currentState?.subdivision ? ` ${currentState?.subdivision}` : ``} property
            value...
          </Modal.Title>
        </Modal.Header>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Modal.Body>
            <p>
              and send me alerts whenever properties
              {currentState?.subdivision ? ` in ${currentState?.subdivision}` : ``} are listed and sold, so
              I always know the value.
              <br />
              Please complete the form below to receive your property analysis.
            </p>
            <Row>
              <Col>
                <Form.Group
                  className="form-floating mb-3"
                  controlId="address"
                >
                  <Form.Control
                    type="text"
                    placeholder="Property Address (Required)"
                    maxLength={256}
                    value={formValues["address"] || ""}
                    onChange={handleChange}
                    required
                  />
                  <Form.Label>Property Address (Required)</Form.Label>
                  <Form.Control.Feedback type="invalid">
                    Please provide property address.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            {MainForm()}
          </Modal.Body>
          <Modal.Footer>
            <Button size="lg" variant="blue" type="submit" disabled={isLoading}>
              {isLoading ? (
                <>
                  Saving{" "}
                  <i
                    role="presentation"
                    className="bi bi-cloud-arrow-up-fill"
                  ></i>
                </>
              ) : (
                <>
                  Email Me My Property Value Analysis &amp; Start My Alerts{" "}
                  <i role="presentation" className="bi bi-caret-right-fill"></i>
                </>
              )}
            </Button>
            <div className="me-auto">
              <i role="presentation" className="bi bi-shield-lock-fill"></i> We
              respect your{" "}
              <a
                href="/real-estate/privacy-policy"
                aria-label="RES Luxury Group - Privacy Policy"
                title="RES Luxury Group - Privacy Policy"
                target="_blank"
              >
                privacy
              </a>{" "}
              and will not share or resell your information.
            </div>
          </Modal.Footer>
          <input
            type="hidden"
            id="neighborhood"
            name="neighborhood"
            value={currentState?.subdivision}
          />
          <input
            type="hidden"
            name="cs"
            id="cs"
            value={formValues["cs"] || 0}
          />
          <input type="hidden" name="ts" id="ts" value={1} />
          <input type="hidden" id="cta" name="cta" value="PropertyAnalysis" />
          <input type="hidden" id="sto" name="sto" value="ruthlead" />
        </Form>
      </Modal>
      <Modal
        size="lg"
        fullscreen="md-down"
        centered={true}
        show={currentState?.currentModal === "relocationbrochure"}
        onHide={() => setModal("")}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Welcome to Citrus County Relocation Brochure
          </Modal.Title>
        </Modal.Header>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Modal.Body>
            <p>
              Please complete the form below to be mailed your free relocation
              brochure.
            </p>
            <Row>
              <Col>
                <Form.Group
                  className="form-floating mb-3"
                  controlId="address"
                >
                  <Form.Control
                    type="text"
                    placeholder="Property Address (Required)"
                    maxLength={256}
                    value={formValues["address"] || ""}
                    onChange={handleChange}
                    required
                  />
                  <Form.Label>Property Address (Required)</Form.Label>
                  <Form.Control.Feedback type="invalid">
                    Please provide property address.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            {MainForm()}
          </Modal.Body>
          <Modal.Footer>
            <Button size="lg" variant="blue" type="submit" disabled={isLoading}>
              {isLoading ? (
                <>
                  Saving{" "}
                  <i
                    role="presentation"
                    className="bi bi-cloud-arrow-up-fill"
                  ></i>
                </>
              ) : (
                <>
                  Send Request{" "}
                  <i role="presentation" className="bi bi-caret-right-fill"></i>
                </>
              )}
            </Button>
            <div className="me-auto">
              <i role="presentation" className="bi bi-shield-lock-fill"></i> We
              respect your{" "}
              <a
                href="/real-estate/privacy-policy"
                aria-label="RES Luxury Group - Privacy Policy"
                title="RES Luxury Group - Privacy Policy"
                target="_blank"
              >
                privacy
              </a>{" "}
              and will not share or resell your information.
            </div>
          </Modal.Footer>
          <input
            type="hidden"
            id="neighborhood"
            name="neighborhood"
            value={currentState?.subdivision}
          />
          <input
            type="hidden"
            name="cs"
            id="cs"
            value={formValues["cs"] || 0}
          />
          <input type="hidden" name="ts" id="ts" value={1} />
          <input type="hidden" id="cta" name="cta" value="relocationbrochure" />
        </Form>
      </Modal>
      <Modal
        size="lg"
        fullscreen="md-down"
        centered={true}
        show={currentState?.currentModal === "ftbseminar"}
        onHide={() => setModal("")}
      >
        <Modal.Header closeButton>
          <Modal.Title>First Time Homebuyer Seminar</Modal.Title>
        </Modal.Header>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Modal.Body>
            <p>
              Please complete the form below to be register to attend RES Luxury
              Group"s FREE First Time Homebuyer event.
            </p>
            <p>
              Space is limited so we have provided three (3) time slots, reserve
              your place now before it fulls up.
            </p>
            {MainForm()}
            <Row>
              <Col>
                <Form.Group
                  className="form-floating mb-3"
                  controlId="situation"
                >
                  <Form.Control
                    type="text"
                    placeholder="Please provide occupation & employer (Required)"
                    maxLength={256}
                    value={formValues["situation"] || ""}
                    onChange={handleChange}
                    required
                  />
                  <Form.Label>
                    Please provide occupation & employer (Required)
                  </Form.Label>
                  <Form.Control.Feedback type="invalid">
                    Please provide occupation & employer.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="timeframe">
                  <Form.Select
                    aria-label="Select session"
                    value={formValues["timeframe"] || ""}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select session</option>
                    <option value="9am">9:00 a.m.</option>
                    <option value="10am">10:00 a.m.</option>
                    <option value="11am">11:00 a.m.</option>
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    Please select session.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button size="lg" variant="blue" type="submit" disabled={isLoading}>
              {isLoading ? (
                <>
                  Saving{" "}
                  <i
                    role="presentation"
                    className="bi bi-cloud-arrow-up-fill"
                  ></i>
                </>
              ) : (
                <>
                  Register{" "}
                  <i role="presentation" className="bi bi-caret-right-fill"></i>
                </>
              )}
            </Button>
            <div className="me-auto">
              <i role="presentation" className="bi bi-shield-lock-fill"></i> We
              respect your{" "}
              <a
                href="/real-estate/privacy-policy"
                aria-label="RES Luxury Group - Privacy Policy"
                title="RES Luxury Group - Privacy Policy"
                target="_blank"
              >
                privacy
              </a>{" "}
              and will not share or resell your information.
            </div>
          </Modal.Footer>
          <input
            type="hidden"
            name="cs"
            id="cs"
            value={formValues["cs"] || 0}
          />
          <input type="hidden" name="ts" id="ts" value={1} />
          <input type="hidden" id="cta" name="cta" value="ftbseminar" />
          <input type="hidden" id="sto" name="sto" value="all" />
        </Form>
      </Modal>
    </>
  );
};

export default MainMenu;
